module.exports = __webpack_public_path__ + "img/pause_button.9483f6fa.svg";